const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: "100vh",
    position: "relative",
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    transition: "background-color 0.3s ease",
  },
  container: {
    width: "90%",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "2rem 0",
    "@media (max-width: 768px)": {
      width: "95%",
      padding: "1rem 0",
    },
  },
  header: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 0",
    marginBottom: "1rem",
  },
  logo: {
    fontSize: "1.5rem",
    fontWeight: "700",
    color: theme.palette.primary.main,
    letterSpacing: "1px",
  },
  hero: {
    display: "flex",
    alignItems: "center",
    gap: "3rem",
    padding: "3.5rem 0 2rem",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      gap: "2rem",
      padding: "2rem 0 1rem",
      textAlign: "center",
    },
  },
  heroContent: {
    flex: "1 1 50%",
    minWidth: 0,
  },
  heroTitle: {
    fontSize: "3.5rem",
    fontWeight: "800",
    margin: "0 0 1.25rem",
    lineHeight: "1.05",
    letterSpacing: "-0.02em",
    "@media (max-width: 1100px)": {
      fontSize: "2.75rem",
    },
    "@media (max-width: 768px)": {
      fontSize: "2.1rem",
    },
  },
  heroSubtitle: {
    fontSize: "1.15rem",
    color: theme.palette.text.secondary,
    maxWidth: "460px",
    margin: "0 0 2rem",
    fontWeight: "400",
    lineHeight: 1.5,
    "@media (max-width: 900px)": {
      margin: "0 auto 2rem",
    },
  },
  heroButtons: {
    display: "flex",
    gap: "0.75rem",
    flexWrap: "wrap",
    "@media (max-width: 900px)": {
      justifyContent: "center",
    },
  },
  primaryButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText || "#fff",
    padding: "0.7rem 1.75rem",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "700",
    fontSize: "1rem",
    lineHeight: 1.5,
    minHeight: "48px",
    boxSizing: "border-box",
    // Pin typography + a transparent border so theme font/variant changes
    // don't resize the hero CTAs (contained vs outlined now share a box).
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    border: "1px solid transparent",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  secondaryButton: {
    borderColor: theme.palette.divider || "rgba(0,0,0,0.2)",
    color: theme.palette.text.primary,
    padding: "0.7rem 1.75rem",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "700",
    fontSize: "1rem",
    lineHeight: 1.5,
    minHeight: "48px",
    boxSizing: "border-box",
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    border: "1px solid",
  },
  // Decorative palette wall on the right of the hero.
  heroArt: {
    flex: "1 1 50%",
    position: "relative",
    minHeight: "360px",
    "@media (max-width: 900px)": {
      display: "none",
    },
  },
  heroGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "0.75rem",
  },
  thumb: {
    display: "flex",
    height: "72px",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
  },
  heroFeature: {
    position: "absolute",
    left: "-4%",
    bottom: "-10%",
    width: "62%",
    height: "190px",
    display: "flex",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 18px 40px rgba(0,0,0,0.22)",
    border: `4px solid ${theme.palette.background.default}`,
  },
  trusted: {
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: "0.12em",
    fontSize: "0.72rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
    opacity: 0.7,
    padding: "1.5rem 0 0.5rem",
  },
  palettesSection: {
    padding: "1rem 0",
  },
  sectionTitle: {
    fontSize: "1.35rem",
    fontWeight: "600",
    marginBottom: "1.25rem",
    opacity: "0.8",
  },
  emptyState: {
    margin: 0,
    padding: "0.75rem 0",
    fontSize: "0.9rem",
    color: theme.palette.text.secondary,
    opacity: 0.8,
  },
  palettes: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "2rem",
  },
  paletteWrapper: {
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "translateY(-4px)",
    },
  },
  dialog: {
    "& .MuiDialog-paper": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    },
  },
});

export default styles;
